import React from 'react';
import { Container, Boxloader, Logo } from './styles';
import ReactLoading from 'react-loading';
import LogoZaivu from '../../assets/Logo-Zaivu.svg';

/**
blank
balls
bars
bubbles
cubes
cylon
spin
spinningBubbles
spokes
 * 
 */
const Loading = () => {



  return (
    <Container>
      <Boxloader>
        <Logo style={{ opacity: 1 }} src={LogoZaivu} />

        <div
          style={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}
        >
          <ReactLoading type="spin" color="#118052" />
          <h1>Carregando..</h1>

        </div>

      </Boxloader>
    </Container>
  );
};

export default Loading;
